import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles/thankyou.css";

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();


  const completedOrder = useMemo(() => {
    const stateOrder = location?.state?.completedOrder;

    if (stateOrder) return stateOrder;

    try {
      const savedOrder = localStorage.getItem("lastCompletedOrder");
      return savedOrder ? JSON.parse(savedOrder) : null;
    } catch {
      return null;
    }
  }, [location]);

  const completedOrderNumber = useMemo(() => {
    return (
      completedOrder?.order?.orderNumber ||
      completedOrder?.order?.trackingNumber ||
      completedOrder?.order?._id ||
      completedOrder?.orderNumber ||
      completedOrder?._id ||
      "your order"
    );
  }, [completedOrder]);

  const shortOrderNumber = useMemo(() => {
    const raw = String(completedOrderNumber || "your order");
    return raw === "your order" ? raw : raw.slice(-10);
  }, [completedOrderNumber]);

  const orderValue = useMemo(() => {
    const rawValue =
      completedOrder?.order?.totalPrice ??
      completedOrder?.order?.total ??
      completedOrder?.order?.amount ??
      completedOrder?.totalPrice ??
      completedOrder?.total ??
      completedOrder?.amount ??
      0;

    const numericValue = Number(rawValue);
    return Number.isFinite(numericValue) ? numericValue : 0;
  }, [completedOrder]);

  const transactionId = useMemo(() => {
    return (
      completedOrder?.order?.orderNumber ||
      completedOrder?.order?.trackingNumber ||
      completedOrder?.order?._id ||
      completedOrder?.orderNumber ||
      completedOrder?._id ||
      null
    );
  }, [completedOrder]);

  useEffect(() => {
    if (!window.gtag) return;
    if (!completedOrder) return;
    if (!transactionId) return;

    const firedKey = `google_ads_purchase_${transactionId}`;
    const alreadyFired = sessionStorage.getItem(firedKey);

    if (alreadyFired) return;

    window.gtag("event", "conversion", {
      send_to: "AW-17466736955/ldDRCPyLhJkcELuC5YhB",
      value: orderValue,
      currency: "UGX",
      transaction_id: String(transactionId),
    });

    sessionStorage.setItem(firedKey, "true");
  }, [completedOrder, transactionId, orderValue]);



  const goToOrderDetails = () => {
    navigate("/my-orders");
  };

  const goHomeAfterOrder = () => {
    navigate("/");
  };

  return (
    <div className="ty-page">
      {/* =========================
          MOBILE / APP UI
      ========================= */}
      <div className="ty-app">
        <div className="ty-appPhoneWrap">
          <div className="ty-appPhone">
            <div className="ty-appBody ty-successScreen">
              <div className="ty-successLogo">✓</div>

              <div className="ty-successGlow">
                <div className="ty-successCircle">
                  <span>✓</span>
                </div>
              </div>

              <h2 className="ty-successTitle">Thank you for shopping with us!</h2>

              <p className="ty-successText">
                Your order <strong>#{shortOrderNumber}</strong> is confirmed and in processing.
              </p>

              <div className="ty-successPill">Your order was placed successfully</div>

              <p className="ty-successHelp">
                Need assistance? We&apos;re here for you. You can review your order details or return home.
              </p>

              <button
                type="button"
                className="ty-successOutlineBtn"
                onClick={goToOrderDetails}
              >
                Order Details
              </button>

              <button
                type="button"
                className="ty-successPrimaryBtn"
                onClick={goHomeAfterOrder}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* =========================
          DESKTOP UI
      ========================= */}
      <div className="ty-desktop">
        <div className="ty-shell">
          <section className="ty-left">
            <div className="ty-successDesktop">
              <div className="ty-successGlow">
                <div className="ty-successCircle">
                  <span>✓</span>
                </div>
              </div>

              <h2 className="ty-successTitle">Thank you for shopping with us!</h2>

              <p className="ty-successText">
                Your order <strong>#{shortOrderNumber}</strong> is confirmed and in processing.
              </p>

              <div className="ty-successPill">Your order was placed successfully</div>

              <p className="ty-successHelp">
                Need assistance? We&apos;re here for you if you have any questions or need support regarding your
                purchase.
              </p>

              <div className="ty-successActions">
                <button
                  type="button"
                  className="ty-successOutlineBtn"
                  onClick={goToOrderDetails}
                >
                  Order Details
                </button>

                <button
                  type="button"
                  className="ty-successPrimaryBtn"
                  onClick={goHomeAfterOrder}
                >
                  Done
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;